import {
  AlignmentType,
  Document,
  HeadingLevel,
  Paragraph,
  Table,
  TableRow,
  TabStopPosition,
  TabStopType,
  TextRun,
  WidthType,
  PageOrientation,
  Header,
  Footer,
  TableCell,
} from "docx";
import Options from "../../../data/options";
import { tablineWithOneTab } from "../summary/tablines1";
import { paragraphArial, paragraphArialBold } from "./paragraphs";

export const gutachterField = (user) => {
  return [
    new Paragraph(""),
    paragraphArialBold(
      `Erstgutachter/in (${user?.firstName} ${user.lastName})`
    ),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    tablineWithOneTab("\t"),
    paragraphArial("Erstgutachter/in / Dienstbezeichung / Datum"),
    new Paragraph(""),
    new Paragraph(""),
    paragraphArialBold("Zweitgutachter/in"),
    new Paragraph(""),
    new Paragraph({
      indent: { left: 360, hanging: 360 },
      children: [
        new TextRun({
          text: `[  ] Nach vollständiger Durchsicht der Arbeit und der Korrektur schließe ich mich dem vorstehenden Gutachten nicht an. Mein Zweitgutachten ist beigefügt.`,
          font: "Arial",
        }),
      ],
    }),
    new Paragraph(""),
    paragraphArial(
      `[  ] Nach vollständiger Durchsicht der Arbeit und der Korrektur schließe ich mich dem vorstehenden Gutachten an.`
    ),

    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    tablineWithOneTab("\t"),
    paragraphArial("Zweitgutachter/in / Dienstbezeichung / Datum"),
  ];
};
